import { Helmet } from 'react-helmet-async'
import { BentoGrid, BentoGridItem } from '../components/ui/BentoGrid'
import GrantaEarthLogo from '../components/ui/GrantaEarthLogo'

export default function Commodities() {
  return (
    <>
      <Helmet>
        <title>Commodities | GrantaEarth Co.</title>
        <meta name="description" content="Trade desk exporting minerals and importing grain, fuel, fertilisers, and bitumen into Zimbabwe." />
      </Helmet>

      <section className="bg-gradient-to-b from-off-white to-white section-padding">
        <div className="container-custom">
          <div className="text-center mb-8">
            <GrantaEarthLogo size="lg" className="mx-auto mb-6" />
          </div>
          
          <h1 className="text-3xl md:text-5xl font-extrabold text-center">Commodities Trade Desk</h1>
          <p className="mt-4 text-center text-gray-700 max-w-3xl mx-auto">
            Cross border flows designed to shorten lead times and reduce currency risk. Documentation and process discipline for reliable execution.
          </p>

          <div className="mt-10">
            <BentoGrid className="md:grid-cols-2">
              <BentoGridItem 
                title="Exports" 
                description="Minerals from Zimbabwe to qualified international buyers. Focus on chrome, gold, and other strategic resources with proper certification."
                icon="📤"
                colSpan="md:col-span-1"
              />
              <BentoGridItem 
                title="Imports" 
                description="Grain, fuel, fertilisers, and bitumen into Zimbabwe for industry and infrastructure. Essential supplies for economic development."
                icon="📥"
                colSpan="md:col-span-1"
              />
              <BentoGridItem 
                title="Trade Structures" 
                description="Conventional purchase, barter, and swap arrangements where appropriate. Flexible solutions tailored to counterparty needs."
                icon="🔄"
                colSpan="md:col-span-1"
              />
              <BentoGridItem 
                title="Compliance Excellence" 
                description="Know your counterparty protocols, quality checks, and comprehensive shipping documentation for all transactions."
                icon="✅"
                colSpan="md:col-span-1"
              />
            </BentoGrid>
          </div>
        </div>
      </section>
    </>
  )
}
